export interface IChatMessage {
    MessageID: string;
    ReplyMessageID: string | null;
    Text: string;
    PersonNickName: string;
    ReplyPersonNickName: string | null;
    Created: string; //svc date
    PersonID: number;
    ReplyPersonID: number;
}

export interface IChatPerson {

    PersonID: number;
    NickName: string;
    PersonType: string; //??
    BlockedTimeFrom: string | null; //?? svc
    BlockedTimeTo: string | null; //?? svc
    BlockedPrivateMess: boolean;
    Beep: boolean;
    HasNickName: boolean;
    BlockedPersons: IBlockedPerson[];
}

export interface IChatMessages {
    Messages: IChatMessage[];
    Person: IChatPerson;
}

export interface IBlockedPerson {
    PersonID: number;
    BlockedPersonID: number;

}

export enum ChatInsertMessageResult {
    Success = 0,
    PrivateBlocked = 1,
    NonExistentReply = 2,
    UserBanned = 3,
    UserNotLogged = 4,
    TimeConstraintFailed = 5,
    Fail = 6
}

export interface InsertMessageOperationResult {
    Result: ChatInsertMessageResult;
    Reason: string;
}

export interface IChatSubscribeResponse {
    Person: IChatPerson;
    Messages: IChatMessage[];
}